import {cloneDeep} from "lodash";

export const convertFilter = (filters) => {
  console.log(filters)
  return cloneDeep(filters)?.map((filter) => {
    if (filter.category === "address") {
      filter.value = filter.label;
    } else if (filter.category === "createdWeek") {
      filter.value = filter.value.split("_")[1];
    } else if (filter.category === "respond") {
      filter.category = filter.category + "_" + filter.value.substring(0, 1)
      filter.value = filter.value.substring(2, 4)
    }
    return {
      category: filter.category,
      value: filter.value,
      label: filter.label,
    };
  });
}